import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { getPlanesData, getVehicleData } from '../../helpers/dataLayerHelpers';
import { getSessionId } from '../../helpers/storageUtils';
import { Cotizacion } from '../../Models/cotizacion';
import { CrearCotizacion } from '../../Models/crearCotizacion';
import { DatosGenerales } from '../../Models/datosGenerales';
import { DatosPlanes } from '../../Models/datosPlanes';
import { Planes } from '../../Models/planes';
import { PipesModule } from '../../pipes/pipes.module';
import { REDIRECT } from '../../routes.constans';
import { CotizacionService } from '../../services/Cotizacion/cotizacion.service';
import { DataLayerService } from '../../services/DataLayer/data-layer.service';
import { LeadsService } from '../../services/Leads/leads.service';
import { TiempoInactivoService } from '../../services/TiempoInactivo/tiempo-inactivo.service';
import { selectCotizacion } from '../../storage/Cotizacion/cotizacion.selectors';
import { selectData } from '../../storage/Lead/data.selectors';
import { selectPlanes } from '../../storage/Planes/planes.selector';
import { BannerAppComponent } from '../banner-app/banner-app.component';
import { FooterAppComponent } from '../footer-app/footer-app.component';

@Component({
  selector: 'app-pago-rechazado',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent, PipesModule],
  templateUrl: './pago-rechazado.component.html',
  styleUrl: './pago-rechazado.component.scss',
})
export class PagoRechazadoComponent implements OnInit {
  // public planes!: Planes;
  public planes!: Cotizacion;

  public planesTemp: Planes | undefined;
  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;

  datosPlanes: DatosPlanes | null = null;
  datosPlanes$: Observable<DatosPlanes | null>;

  datosCotizacion: CrearCotizacion | null = null;
  datosCotizacion$: Observable<CrearCotizacion | null>;

  sessionId = '';
  public fecha = '';
  date: Date = new Date();

  tipoPago: string | undefined;
  PagoPlan: any;
  valorAntesE = 0;
  valorAntesT = 0;
  valorAntesP = 0;

  valorAPagar = 0;
  valorSubTotal = 0;
  valorMes = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(LOCALE_ID) public locale: string,
    private store: Store,
    private leadServices: LeadsService,
    private tiempoInactivo: TiempoInactivoService,
    private cotizacion: CotizacionService,
    private dataLayerService: DataLayerService,
  ) {
    console.log('pago rechazado');
    this.datosGenerales$ = this.store.select(selectData);
    this.datosPlanes$ = this.store.select(selectPlanes);
    this.datosCotizacion$ = this.store.select(selectCotizacion);
  }
  ngOnInit(): void {
    this.fecha = `${this.date.getFullYear()}-${this.date.getMonth() + 1}-${
      this.date.getDate() + 1
    }`;
    this.sessionId = getSessionId().toString();

    combineLatest([this.datosGenerales$, this.datosPlanes$, this.datosCotizacion$])
      .pipe(take(1))
      .subscribe(([generales, planes, cotizacion]) => {
        this.datosGenerales = generales;
        this.planesTemp = planes?.planes;
        this.datosPlanes = planes;
        this.datosCotizacion = cotizacion;

        this.tipoPago = this.datosPlanes?.payment_frequency;
        this.PagoPlan = this.planesTemp?.data.products.find(
          (plan) => plan.code === this.datosPlanes?.selected_plan,
        );

        if (this.datosPlanes?.selected_plan === 'MOTOS_PlanEsencial') {
          const valorE = this.PagoPlan.priceMensual.amount * 0.2;
          this.valorAntesE = this.PagoPlan.priceMensual.amount + valorE;
          this.valorSubTotal = this.valorAntesE;
        }

        if (this.datosPlanes?.selected_plan === 'MOTOS_PlanTotal') {
          const valorT = this.PagoPlan.priceMensual.amount * 0.2;
          this.valorAntesT = this.PagoPlan.priceMensual.amount + valorT;
          this.valorSubTotal = this.valorAntesT;
        }

        if (this.datosPlanes?.selected_plan === 'MOTOS_PlanPremium') {
          const valorP = this.PagoPlan.priceMensual.amount * 0.2;
          this.valorAntesP = this.PagoPlan.priceMensual.amount + valorP;
          this.valorSubTotal = this.valorAntesP;
        }

        if (this.PagoPlan) {
          this.valorMes = this.PagoPlan.priceMensual.amount;
          this.valorAPagar =
            this.tipoPago === 'Monthly'
              ? this.PagoPlan.priceMensual.amount / 12
              : this.PagoPlan.priceAnual.amount;
        }

        // Misma pestaña: el store tiene datos reales del flujo (no el estado inicial vacío)
        if (generales?.Lead?.plate || planes?.selected_plan) {
          this.pushDataLayer('Pageview');
        }
      });

    this.getParamPrepolicyId();
  }

  redirect() {
    this.pushDataLayer('Button');
    this.router.navigate([REDIRECT]);
  }

  private getParamPrepolicyId(): void {
    this.route.queryParams.subscribe((params) => {
      const prepolicyid = params['prepolicyid'];
      if (prepolicyid) {
        this.cotizacion.getCotizacion(this.sessionId, prepolicyid).subscribe(
          (data) => {
            this.planes = data;

            // Actualizar valores de visualización desde la API (pestaña nueva o recarga)
            const price = data.data?.plan?.price;
            this.tipoPago = data.data?.plan?.paymentFrecuency;
            this.valorAPagar =
              this.tipoPago === 'Monthly'
                ? (price?.price_monthly?.amount ?? 0)
                : (price?.full?.amount ?? 0);

            // Pestaña nueva: store sin datos reales → disparar taggeo con datos de la API
            if (!this.datosGenerales?.Lead?.plate && !this.datosPlanes?.selected_plan) {
              this.pushDataLayer('Pageview');
            }
          },
          (error) => {
            console.error('Error al obtener cotización');
          },
        );
      }
    });
  }

  pushDataLayer(ecom_item: 'Pageview' | 'Button' | undefined): void {
    if (this.planes?.data) {
      const asset = this.planes.data.asset;
      const plan = this.planes.data.plan;
      const rawSelected = plan.selected as any;
      const plan_seleccionado =
        typeof rawSelected === 'string'
          ? rawSelected
          : rawSelected?.Selected || rawSelected?.selected || '';
      const valor_plan =
        plan.paymentFrecuency === 'Monthly'
          ? plan.price?.price_monthly?.amount
          : plan.price?.full?.amount;

      this.dataLayerService.pushDataLayer({
        event: 'moto_ecommerce_step_7_pago_rechazado',
        ecom_tipo: 'Moto',
        ecom_pantalla: 'Pago rechazado',
        ecom_item,
        zona_circulacion: plan.zonaCirculacion || '',
        uso_vehiculo: 'Particular',
        placa: asset.plate || '',
        marca_vehiculo: asset.brand || '',
        modelo_vehiculo: asset.model || '',
        cilindraje_vehiculo: asset.cylinder || '',
        plan_seleccionado,
        periodicidad_pago: plan.paymentFrecuency || '',
        valor_plan,
        user_id: this.sessionId,
      });
    } else {
      this.dataLayerService.pushDataLayer({
        event: 'moto_ecommerce_step_7_pago_rechazado',
        ecom_tipo: 'Moto',
        ecom_pantalla: 'Pago rechazado',
        ecom_item,
        ...getVehicleData(this.datosGenerales),
        ...getPlanesData(this.datosPlanes),
        user_id: this.sessionId,
      });
    }
  }
}
